// API imperativa de notificações (substitui o window.alert).
// Pode ser chamada de qualquer lugar: notify.success("..."), notify.error("..."), etc.
// O <FeedbackProvider /> é quem renderiza as mensagens na tela.

let listeners = [];
let nextId = 1;

const emit = (severity, message, options = {}) => {
    const toast = {
        id: nextId++,
        severity,
        message: typeof message === 'string' ? message : String(message ?? ''),
        title: options.title,
        duration: options.duration ?? (severity === 'error' ? 7000 : 5000),
    };
    listeners.forEach((listener) => listener(toast));
    return toast.id;
};

export const notify = {
    success: (message, options) => emit('success', message, options),
    error: (message, options) => emit('error', message, options),
    warning: (message, options) => emit('warning', message, options),
    info: (message, options) => emit('info', message, options),
};

export const subscribeNotify = (listener) => {
    listeners.push(listener);
    return () => {
        listeners = listeners.filter((l) => l !== listener);
    };
};

// Diálogo de confirmação baseado em Promise (substitui o window.confirm).
let confirmHandler = null;

export const registerConfirmHandler = (handler) => {
    confirmHandler = handler;
    return () => {
        if (confirmHandler === handler) confirmHandler = null;
    };
};

export const confirmDialog = (options) => {
    if (!confirmHandler) return Promise.resolve(window.confirm(options?.message || 'Confirmar?'));
    return confirmHandler(typeof options === 'string' ? { message: options } : options);
};

// Extrai uma mensagem legível de um erro do axios.
export const getErrorMessage = (error, fallback = 'Ocorreu um erro inesperado. Tente novamente.') =>
    error?.response?.data?.message || error?.response?.data?.error || error?.response?.data?.erro || error?.response?.data?.mensagem || fallback;
